import Snackbar from '@mui/material/Snackbar';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import { setSnackbarState } from '../../redux/features/snackbarSlice';

const NVSnackbar = () => {
  const snackbarState = useSelector(state => state?.snackbar);

  const reduxDispatch = useDispatch();

  const handleOnClose = () => {
    reduxDispatch(
      setSnackbarState({
        open: false,
        message: '',
        type: 'info',
      })
    );
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={snackbarState?.open}
      key={'topcenter'}
      autoHideDuration={2000}
      onClose={handleOnClose}
    >
      <Alert severity={snackbarState?.type} sx={{ width: '100%' }}>
        {snackbarState?.message}
      </Alert>
    </Snackbar>
  );
};

export default NVSnackbar;
